import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { getStatusUsingWindow } from '.';
import PhaseType from 'types/phase';

export const due_date_updated = ({ phase, event: { kind, data, status } }) => {
  const date = moment(data.new_due_date).local().format('MM/DD/YYYY h:mm a');
  return (<div className={kind}>
    Due Date Updated for {getStatusUsingWindow(phase, status)} Status.<br />Set to {date}.
  </div>);
};

due_date_updated.defaultProps = { phase: {} };

due_date_updated.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      new_due_date: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/due_date_updated.jsx